// src/App.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';
import BackgroundBlochSphere from './components/BackgroundBlochSphere';
import { Typewriter } from 'react-simple-typewriter';

function App() {
  const navigate = useNavigate();

  const handleEnter = () => {
    navigate('/main');
  };

  return (
    <div className="app-container">
      <BackgroundBlochSphere />

      <img src="/saksham1.jpg" className="profile-pic" alt="Saksham Prajapati" />

      <h1 className="animated-heading">
        {"Hi, I am Saksham Prajapati".split("").map((char, index) => (
          <span key={index} className="letter">
            {char === " " ? "\u00A0" : char}
          </span>
        ))}
      </h1>

      <p className="typewriter-text">
        <Typewriter
          words={['M.Sc. Student in Quantum Science & Technology', 'Quantum Tech Enthusiast', 'Data Visualization/Simulation']}
          loop={true}
          cursor
          cursorStyle="|"
          typeSpeed={70}
          deleteSpeed={40}
          delaySpeed={1200}
        />
      </p>

      <div className="button-group">
        <a href="/Saksham_Resume.pdf" download className="btn">Download CV</a>
        <button className="btn" onClick={handleEnter}>Enter Website</button>
      </div>

      <p className="site-credit-main">
        Design, concept and creativity by Saksham. Coded with ChatGPT.
      </p>
    </div>
  );
}

export default App;
